import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNoAiStore } from '../../stores/noAiStore';
import { isDevToolsEnabled } from '../../env';
import { TranslationKey } from '../../i18n/translationKeys';
import { Switch } from '../../ui/Switch/Switch';

export const NoAiToggle: React.FC = () => {
    const { t } = useTranslation();
    const { noAi, toggle } = useNoAiStore();

    if (!isDevToolsEnabled) return null;

    const label = t(TranslationKey.Settings.NoAiMode);

    return (
        <div data-testid="header-no-ai-toggle" className="flex items-center gap-s px-s">
            <span className="text-s font-medium text-content-subtle">{label}</span>
            <Switch testId="header-no-ai-switch" checked={noAi} onChange={toggle} label={label} />
        </div>
    );
};
